import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Clock, ArrowRight } from 'lucide-react';
import Logo from '../components/common/Logo';
import { useAuth } from '../contexts/AuthContext';
import { waBilling } from '../utils/support';
import { track } from '../utils/analytics';

const SubscriptionResult = ({ success }) => {
  const { billingState, refreshProfile } = useAuth();
  const [activated, setActivated] = useState(billingState?.source === 'payments_hub' && billingState?.active === true);
  const conversionTracked = useRef(false);

  useEffect(() => {
    track(success ? 'checkout_returned_success' : 'checkout_returned_cancelled', {
      billing_source: billingState?.source || 'unknown',
    });
    if (!success) track('checkout_abandoned', { stage: 'provider_checkout' });
  }, [success]);

  useEffect(() => {
    if (!success) return;
    let tries = 0;
    const interval = setInterval(async () => {
      tries += 1;
      await refreshProfile();
      track('payment_activation_polled', { attempt: tries });
      if (tries >= 6) clearInterval(interval);
    }, 5000);
    return () => clearInterval(interval);
  }, [success]);

  useEffect(() => {
    const paid = billingState?.source === 'payments_hub' && billingState?.active === true;
    setActivated(paid);
    if (success && paid && !conversionTracked.current) {
      conversionTracked.current = true;
      track('subscription_activated', {
        plan_tier: billingState?.tier || 'unknown',
        billing_source: 'payments_hub',
      });
      track('purchase_completed', {
        plan_tier: billingState?.tier || 'unknown',
        billing_source: 'payments_hub',
      });
    }
  }, [success, billingState?.source, billingState?.active, billingState?.tier]);

  return (
    <div className="min-h-screen bg-paper-alt flex flex-col items-center justify-center p-4">
      <Link to="/painel" className="mb-8" aria-label="Laudando Online">
        <Logo markClassName="h-10 w-10" />
      </Link>
      <div className="max-w-md w-full bg-paper rounded-card shadow-card border border-line p-8 text-center">
        {success ? (
          <>
            <div className="w-16 h-16 bg-selo-tint text-selo rounded-card flex items-center justify-center mx-auto mb-6"><ShieldCheck className="w-8 h-8" aria-hidden="true" /></div>
            <h1 className="font-display text-2xl font-bold text-navy mb-2">Pagamento confirmado</h1>
            <p className="text-sm text-muted mb-6">{activated ? 'Seu plano já está ativo.' : 'A ativação do plano leva alguns instantes e aparece nesta tela.'}</p>
            {!activated && <div className="flex items-center justify-center gap-2 text-xs text-muted mb-6"><Clock className="w-4 h-4 animate-spin" aria-hidden="true" />Ativando seu plano…</div>}
            <Link to="/painel" className="btn-convert w-full">Ir para o Dashboard <ArrowRight className="w-4 h-4" aria-hidden="true" /></Link>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-paper-alt text-muted rounded-card flex items-center justify-center mx-auto mb-6"><Clock className="w-8 h-8" aria-hidden="true" /></div>
            <h1 className="font-display text-2xl font-bold text-navy mb-2">Pagamento não concluído</h1>
            <p className="text-sm text-muted mb-6">Você saiu do checkout antes de finalizar. Nenhuma cobrança foi confirmada. Você pode tentar novamente quando quiser.</p>
            <div className="space-y-3">
              <Link to="/planos" className="btn-primary w-full">Ver os planos novamente</Link>
              <a href={waBilling()} target="_blank" rel="noopener noreferrer" className="btn-secondary w-full">Falar com o suporte</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscriptionResult;
